import { addClassName } from '@hc-frontend/core-utils-format';

import { StepProgressProps } from './step-progress.types';

export function StepProgress({
  steps,
  currentStep,
  className,
}: StepProgressProps) {
  return (
    <div
      aria-label="Progress..."
      role="status"
      className={addClassName('flex justify-center w-full gap-8-8', className)}
    >
      {Array.from({ length: steps }).map((_, idx) => {
        const isActive = idx <= currentStep;
        return (
          <div
            key={idx}
            className={addClassName(
              'h-4-4 w-40-40 rounded bg-gray-200 transition-all',
              isActive ? 'bg-secondary-900' : 'bg-gray-200',
            )}
          />
        );
      })}
    </div>
  );
}
